import {createWebPlatform} from '../platform/web.js';
import {ShiftGame} from '../game/game.js';
const platform=createWebPlatform();
try{new ShiftGame(platform).start();}catch(error){platform.reportError(error);}
